import React, { useCallback, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CButton, CCard, CCardBody, CCardHeader, CCol, CForm, CRow } from '@coreui/react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { TYPE_SHOW_UNSAVE_CHANGE } from '../../../../../../../../constants';

import CenterSpinner from '../../../../../../../general/Loadings/CenterSpinner';
import { CInput, CTextarea } from '../../../../../../../migration/CInput';
import { CInvalidFeedback } from '../../../../../../../migration/CInvalidFeedback';
import CLabel from '../../../../../../../migration/CLabel';
import CFormGroup from '../../../../../../../migration/CFormGroup';

import { setRuleHaveEditting } from '../../../../../../../../actions/common';

import { RuleContext } from '../CreateFormCrawlRule';

const Step2 = () => {
     const { rule, activeStep, setActiveStep, setRule, activeListener } = useContext(RuleContext);

     const dispatch = useDispatch();
     const rulesLoading = useSelector((state) => state.subscriber.loadings.allRules);
     const formCrawlRules = useSelector((state) => state.subscriber.formCrawlRules);

     const initialValues = {
          name: rule.name,
          description: rule.description,
     };

     const rules = useMemo(() => {
          if (!formCrawlRules || !activeListener) return [];

          return formCrawlRules.filter((rule) => rule.listenerId === activeListener.id);
     }, [formCrawlRules, activeListener])

     const validationSchema = useCallback(() => {
          const ruleNames = rules.map((rule) => rule.name);

          if (rule.name) {
               let ruleNameIndex = -1;

               ruleNames.some((ruleName, index) => {
                    if (rule.name === ruleName) {
                         ruleNameIndex = index;
                         return true;
                    }

                    return false;
               });

               if (ruleNameIndex !== -1) {
                    ruleNames.splice(ruleNameIndex, 1);
               }
          }

          return Yup.object().shape({
               name: Yup.string()
                    .trim()
                    .required('Name is required')
                    .max(200, 'Name cannot be more than 200 characters')
                    .notOneOf(ruleNames, 'Existed name, please choose another name'),
          });
     }, [rules, rule.name]);

     const onSubmit = ({ name, description }, { setSubmitting }) => {
          setSubmitting(false);
          const data = {
               name: name.trim(),
               description: description.trim(),
          };
          const newStepsData = { ...rule, ...data };
          setRule(newStepsData);
          setActiveStep(3);
     };

     const handleHasChange = () => {
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.CREATE_LOOKUP }));
     };

     return (
          <CCard className={`cvr-step-2 ${activeStep === 2 ? 'cvr-step-card' : 'difference-step'}`}>
               <CCardHeader>
                    {activeStep === 2 ? (
                         <h5>Step 2: Rule Name & Description</h5>
                    ) : (
                         <div className="rule-step d-inline-flex justify-content-between w-100">
                              <h5 className="mb-0 inactive">Step 2: Rule Name & Description</h5>
                              {rule.name && (
                                   <div className="d-inline-flex align-items-center">
                                        <span className="given-data mr-3">{rule.name}</span>
                                        <CButton className="btn-edit" onClick={() => setActiveStep(2)}>
                                             Edit
                                        </CButton>
                                   </div>
                              )}
                         </div>
                    )}
               </CCardHeader>
               {activeStep === 2 && (
                    <CCardBody>
                         {rulesLoading ? (
                              <CenterSpinner />
                         ) : (
                              <Formik
                                   initialValues={initialValues}
                                   validationSchema={validationSchema}
                                   onSubmit={onSubmit}
                                   validateOnChange={false}
                                   validateOnBlur={false}
                              >
                                   {({ values, errors, handleChange, handleSubmit, setErrors, isSubmitting }) => (
                                        <CForm onSubmit={handleSubmit} noValidate>
                                             <CRow>
                                                  <CCol xl="7">
                                                       <CFormGroup>
                                                            <CLabel htmlFor="name">Name this rule set</CLabel>
                                                            <CInput
                                                                 id="name"
                                                                 placeholder="Rule set name"
                                                                 invalid={!!errors.name}
                                                                 disabled={isSubmitting}
                                                                 value={values.name}
                                                                 onChange={(e) => {
                                                                      handleChange(e);
                                                                      handleHasChange();
                                                                      if (errors) {
                                                                           setErrors({});
                                                                      }
                                                                 }}
                                                                 data-lpignore="true"
                                                            />
                                                            <CInvalidFeedback>{errors.name}</CInvalidFeedback>
                                                       </CFormGroup>
                                                  </CCol>
                                                  <CCol xl="12">
                                                       <CFormGroup>
                                                            <CLabel htmlFor="description">Describe this rule set</CLabel>
                                                            <CTextarea
                                                                 id="description"
                                                                 placeholder="Enter a description for your own reference..."
                                                                 disabled={isSubmitting}
                                                                 value={values.description}
                                                                 onChange={(e) => {
                                                                      handleChange(e);
                                                                      handleHasChange();
                                                                 }}
                                                                 data-lpignore="true"
                                                            />
                                                       </CFormGroup>
                                                  </CCol>
                                             </CRow>
                                             <CButton type="submit" className="px-4" color="primary">
                                                  NEXT STEP
                                             </CButton>
                                        </CForm>
                                   )}
                              </Formik>
                         )}
                    </CCardBody>
               )}
          </CCard>
     );
};

export default Step2;
